/**
 * アクティブなポップアップを管理するユーティリティ
 * 現在開いているポップアップの識別情報を保持し、
 * PropertySelectionGridからの更新を適切なポップアップに配信する
 */

interface ActivePopupInfo {
  location: string;
  chiban: string;
  prefName: string;
  pinType:
    | "map-click"
    | "owner-plot"
    | "saved-plot"
    | "real-estate-search"
    | "reception-book";
}

// 現在アクティブなポップアップ情報を保持
let activePopup: ActivePopupInfo | null = null;

/**
 * アクティブなポップアップ情報を設定
 * @param info ポップアップ識別情報
 */
export const setActivePopup = (info: ActivePopupInfo | null): void => {
  activePopup = info;
};

/**
 * アクティブなポップアップ情報を取得
 * @returns 現在のアクティブなポップアップ情報
 */
export const getActivePopup = (): ActivePopupInfo | null => {
  return activePopup;
};

/**
 * アクティブなポップアップ情報をクリア
 */
export const clearActivePopup = (): void => {
  activePopup = null;
};

/**
 * 指定された行がアクティブなポップアップと一致するかチェック
 * @param location 所在
 * @param chiban 地番
 * @param prefName 都道府県名
 * @param pinType ピンタイプ
 * @returns 一致する場合はtrue
 */
export const isActivePopup = (
  location: string,
  chiban: string,
  prefName: string,
  pinType: string
): boolean => {
  if (!activePopup) return false;

  return (
    activePopup.location === location &&
    activePopup.chiban === chiban &&
    activePopup.prefName === prefName &&
    activePopup.pinType === pinType
  );
};
